import React from 'react';

import { MarkNode } from '../../../types/ContentAst';
import { AnyHtmlAttributes } from '../types/slate';

interface Props {
  attributes: AnyHtmlAttributes;
  children: React.ReactNode;
  leaf: MarkNode;
}

export const Leaf = ({ attributes, children, leaf }: Props) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.strikethrough) {
    children = <s>{children}</s>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
};
